import PageWrapper, { LoadingWrapper } from "app/components/PageWrapper";
import React, { useContext } from "react";

import { Card } from "features/admin/AdminMainPage";
import HStack from "shared/components/layout/stack/HStack";
import Loading from "shared/components/feedback/loading/Loading";
import PropTypes from "prop-types";
import SessionContext from "app/contexts/SessionContext";
import useAllPages from "shared/hooks/useAllPages";
import { usePageAccess } from "shared/hooks/access/usePageAccess";

export const ProjectCard = ({ to, ...rest }) => {
    const session = useContext(SessionContext);
    const { authorized } = usePageAccess(to, session?.legacyId, session?.currentDepartmentId);
    return authorized ? <Card to={to} {...rest} /> : <></>;
};

ProjectCard.propTypes = {
    to: PropTypes.string,
};

const ProjectsMainPage = () => {
    const { pages } = useAllPages();

    if (pages.isLoading) {
        return (
            <LoadingWrapper>
                <Loading text="Loading Page" />
            </LoadingWrapper>
        );
    }

    if (pages.isError) {
        return <>Error</>;
    }

    const adminModuleElements = pages.data.filter(
        (d) => d.module === "Projects"
    );

    const adminSections = adminModuleElements.filter(
        (element) => element.parentID
    );

    return (
        <PageWrapper title="Projects">
            <HStack spacing="Two" style={{ paddingTop: "32px" }}>
                {adminSections.map((data) => (
                    <ProjectCard
                        key={data.route}
                        title={data.name}
                        description={data.description}
                        to={data.route}
                    />
                ))}
            </HStack>
        </PageWrapper>
    );
};

export default ProjectsMainPage;
